import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import MapFilterModel, {
  ModifiedMapFilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import removeUndefinedFields from "@app/util/removeUndefinedFields";
import { areFiltersEqual } from "@app/util/viewModel/comparators";

import { FILTER_ENTITY_TYPES } from "./consts";

const isFilterChanged = (filter: MapFilterModel, modifiedFilter: ModifiedMapFilterModel): boolean =>
  FILTER_ENTITY_TYPES.some((entityType) => {
    if (filter[entityType] && modifiedFilter[entityType]) {
      return !areFiltersEqual(
        filter[entityType]!,
        removeUndefinedFields(modifiedFilter[entityType]!) as FilterModel
      );
    }
    return (
      !!filter[entityType] ||
      (!!modifiedFilter[entityType] && Object.keys(modifiedFilter[entityType]!).length > 0)
    );
  });

export default isFilterChanged;
